import { Box, Tooltip, Typography, Link } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import React from 'react';
import { CrownIcon } from '../../../assets/Svg';
import settings from '../../../services/settings';
import useStyles from './CommentUser.styles';

interface IProps {
  userId: number;
  isWriter?: boolean;
  displayName?: string;
  username?: string;
  isDeletedUser?: boolean;
}

const CommentUser = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { userId, isWriter, displayName, username, isDeletedUser } = props;

  return (
    <Box className={classes.wrap} overflow="hidden">
      {Boolean(isDeletedUser) && <span className={classes.content}>Deleted User</span>}
      {Boolean(!isDeletedUser) && (
        <React.Fragment>
          <PersonIcon className={classes.personIcon} />
          <Tooltip title="User ID">
            <Link href={`${settings.getCrewURI()}/users/${userId}`} target="_blank" className={classes.contentLink}>
              {userId}
            </Link>
          </Tooltip>
          {isWriter && displayName && (
            <Typography className={classes.contentWriter}>
              <span className={classes.crownIcon}>
                <CrownIcon color={settings.getThemeColor()} />
              </span>
              <span>{displayName}</span>
            </Typography>
          )}
          {!isWriter && displayName && (
            <Tooltip title={`Display name: ${displayName}`}>
              <Typography className={classes.contentDesc3}>{displayName}</Typography>
            </Tooltip>
          )}
          {username && (
            <Tooltip title="User name">
              <Typography className={classes.contentDesc3}>{username}</Typography>
            </Tooltip>
          )}
        </React.Fragment>
      )}
    </Box>
  );
};

export default React.memo(CommentUser);
